import QueryString from 'query-string';
import { toastr } from 'react-redux-toastr';
import { MAINTENANCE_ACTIVITY_SYSTEM_ENDPOINT } from '../../config/endpoints';
import { DEFAULT_GET_CONFIG } from '../../config/rest';
import { isErrorResponse } from '../../utils/error-handlers';
import {
  CLEAR_MAINTENANCE_ACTIVITY_SYSTEMS,
  FLAG_GETTING_MAINTENANCE_ACTIVITY_SYSTEMS,
  GET_MAINTENANCE_ACTIVITY_SYSTEMS,
} from '../types';

const flagGettingMaintenanceActivtySystems = (flag) => (dispatch) =>
  dispatch({
    type: FLAG_GETTING_MAINTENANCE_ACTIVITY_SYSTEMS,
    payload: flag,
  });

const getMaintenanceActivtySystems =
  async (tableFilters) => async (dispatch) => {
    try {
      dispatch(flagGettingMaintenanceActivtySystems(true));
      const query = tableFilters;
      const url = `${MAINTENANCE_ACTIVITY_SYSTEM_ENDPOINT}?${QueryString.stringify(
        query,
      )}`;
      const promise = await fetch(url, DEFAULT_GET_CONFIG);
      await isErrorResponse(promise, null, dispatch);
      const response = await promise.json();

      dispatch({
        type: GET_MAINTENANCE_ACTIVITY_SYSTEMS,
        payload: response,
      });
    } catch ({ message }) {
      toastr.error('Error', message);
    } finally {
      dispatch(flagGettingMaintenanceActivtySystems(false));
    }
  };

const clearMaintenanceActivtySystems = () => (dispatch) => {
  dispatch({
    type: CLEAR_MAINTENANCE_ACTIVITY_SYSTEMS,
  });
};

export { getMaintenanceActivtySystems, clearMaintenanceActivtySystems };
